exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background-slider[data-v-493a6d34],.background-slider .slide-item[data-v-493a6d34],.background-slider[data-v-493a6d34]:after{top:0;left:0;right:0;bottom:0;position:absolute}.background-slider[data-v-493a6d34]{z-index:0}.background-slider[data-v-493a6d34]:after{content:\"\";z-index:-1;background-color:#000}.background-slider .slide-item[data-v-493a6d34]{opacity:0;z-index:0;transition:opacity 1.5s;background-size:cover;background-repeat:no-repeat;background-position:50% 50%}.background-slider .slide-item.showing[data-v-493a6d34]{opacity:.7;z-index:1}", ""]);

// exports
